import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes";

function App() {
  // Global scroll listener to close MUI dropdowns application-wide when the background scrolls
  useEffect(() => {
    const handleScroll = (e) => {
      // If we can check closest, ensure we aren't scrolling the dropdown itself
      if (e.target && typeof e.target.closest === 'function') {
        if (e.target.closest('.MuiMenu-paper') || e.target.closest('.MuiPopover-paper')) return;
      }

      // Close the dropdown cleanly by triggering a native click on the backdrop or body
      const backdrop = document.querySelector('.MuiBackdrop-root');
      if (backdrop) {
        backdrop.click();
      } else if (document.querySelector('.MuiPopover-root') || document.querySelector('.MuiMenu-root')) {
        document.body.click();
      }
    };
    
    window.addEventListener('scroll', handleScroll, { capture: true });
    return () => window.removeEventListener('scroll', handleScroll, { capture: true });
  }, []);

  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
